// src/pages/auth/ForgotPassword.js
// Page mot de passe oublié - NE PAS MODIFIER

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);

  const handleSubmit = () => {
    if (email.trim()) {
      // TODO: Appeler l'API forgot-password
      setSent(true);
    }
  };

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      padding: '16px',
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      marginBottom: '32px',
    },
    backButton: {
      background: 'none',
      border: 'none',
      color: '#FFFFFF',
      fontSize: '20px',
      cursor: 'pointer',
    },
    logoSection: { textAlign: 'center', marginBottom: '24px' },
    logoTitle: { fontSize: '24px', fontWeight: '700', color: '#FFD700' },
    description: {
      fontSize: '14px',
      color: '#A0AEC0',
      textAlign: 'center',
      lineHeight: '1.5',
      marginBottom: '24px',
    },
    form: { display: 'flex', flexDirection: 'column', gap: '16px' },
    field: { display: 'flex', flexDirection: 'column', gap: '6px' },
    label: { fontSize: '13px', fontWeight: '600', color: '#A0AEC0' },
    input: {
      padding: '14px 16px',
      backgroundColor: '#111827',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      borderRadius: '8px',
      color: '#FFFFFF',
      fontSize: '15px',
      outline: 'none',
    },
    button: {
      padding: '16px',
      backgroundColor: '#FFD700',
      border: 'none',
      borderRadius: '10px',
      color: '#0A0E1A',
      fontSize: '16px',
      fontWeight: '700',
      cursor: 'pointer',
      marginTop: '8px',
    },
    successBox: {
      padding: '24px',
      backgroundColor: 'rgba(72, 187, 120, 0.1)',
      border: '1px solid rgba(72, 187, 120, 0.3)',
      borderRadius: '12px',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
    },
    successIcon: { fontSize: '40px' },
    successText: { fontSize: '14px', color: '#48BB78', lineHeight: '1.5' },
    link: { color: '#FFD700', fontSize: '14px', cursor: 'pointer', textAlign: 'center', marginTop: '20px' },
  };

  return (
    <div style={styles.container}>
      <Helmet>
        <title>Mot de passe oublié | Fynho</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div style={styles.header}>
        <button style={styles.backButton} onClick={() => navigate('/login')}>←</button>
      </div>

      <div style={styles.logoSection}>
        <div style={styles.logoTitle}>Mot de passe oublié</div>
      </div>

      {sent ? (
        <div style={styles.successBox}>
          <div style={styles.successIcon}>✉️</div>
          <div style={styles.successText}>
            Si un compte existe avec cet email, vous recevrez un lien de réinitialisation.
          </div>
        </div>
      ) : (
        <>
          <div style={styles.description}>
            Entrez votre email pour recevoir un lien de réinitialisation de mot de passe.
          </div>
          <div style={styles.form}>
            <div style={styles.field}>
              <label style={styles.label}>Email</label>
              <input
                type="email"
                style={styles.input}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="votre@email.com"
              />
            </div>
            <button style={styles.button} onClick={handleSubmit}>
              Envoyer le lien
            </button>
          </div>
        </>
      )}

      <div style={styles.link} onClick={() => navigate('/login')}>
        Retour à la connexion
      </div>
    </div>
  );
};

export default ForgotPassword;